module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "mizz-st-bears-logo.99371202.svg";